const  GeneralColumnCell = ({data}) => {
    return (
        <div style={{textAlign:"center",  fontSize: "smaller"}}>{data}</div>
    );
};
export default GeneralColumnCell;